{
  "cycle.entite.organisation_export_siem": "Organisation SIEM destination",
  "cycle.entite.organisation_export_siem_envois": "Sends to the organisation SIEM",
  "journalAudit.action.audit.package_downloaded": "Organisation audit package downloaded",
  "journalAudit.action.org.siem_configured": "Organisation SIEM destination saved",
  "v8e.journal.acteur": "Actor",
  "v8e.journal.acteurInconnu": "unknown actor",
  "v8e.journal.action": "Action",
  "v8e.journal.arretsDUrgence": "Emergency stop history",
  "v8e.journal.au": "To (excluded)",
  "v8e.journal.aucunResultat": "No entry for these filters.",
  "v8e.journal.automatiques": "Include automatic events",
  "v8e.journal.categorie": "Category",
  "v8e.journal.categorie.facturation": "Billing (if you can see it)",
  "v8e.journal.categorie.ia": "AI",
  "v8e.journal.categorie.membres": "Members and invitations",
  "v8e.journal.categorie.profils": "Profiles and rights",
  "v8e.journal.categorie.programmes": "Programmes",
  "v8e.journal.categorie.projets": "Projects",
  "v8e.journal.categorie.securite": "Security and access",
  "v8e.journal.categorie.technologies": "Technologies",
  "v8e.journal.categorie.toutes": "All",
  "v8e.journal.chaineRompue": "broken chain",
  "v8e.journal.chaineVerifiee": "verified chain",
  "v8e.journal.code.CONFLIT_CONCURRENT": "The destination was changed meanwhile: reload the page and try again.",
  "v8e.journal.code.EGRESS_HOST_NOT_ALLOWED": "This host is not in the operator’s allowed outbound list.",
  "v8e.journal.code.EGRESS_METADATA_BLOCKED": "This address targets cloud metadata: it is refused.",
  "v8e.journal.code.PROVIDER_SECRET_UNAVAILABLE": "The referenced secret is missing from the secret store.",
  "v8e.journal.code.V8E_PAQUET_TROP_VOLUMINEUX": "Too many rows for a package (over 200,000): shorten the period.",
  "v8e.journal.code.V8E_SIEM_ADRESSE_INTERNE": "This address leads to an internal network: it is refused.",
  "v8e.journal.code.V8E_SIEM_FACTURATION_NON_TENUE": "Including billing requires the right to see it.",
  "v8e.journal.code.V8E_SIEM_HTTPS_EXIGE": "The SIEM address must start with https://.",
  "v8e.journal.code.V8E_SIEM_REFERENCE_HORS_ORGANISATION": "The secret reference must look like org-<organisation>-siem-<name>, name in lowercase letters and digits.",
  "v8e.journal.conservationSansProjet": "Retention and purge are still set per project: open a project in the context selector.",
  "v8e.journal.csvPret": "The CSV for the chosen filters has been downloaded.",
  "v8e.journal.datesInversees": "The start date must be before the end date.",
  "v8e.journal.deplier": "Show technical details",
  "v8e.journal.detail": "Entry details",
  "v8e.journal.du": "From",
  "v8e.journal.envoi.en_echec": "{{quand}} — sending failed, code {{code}}.",
  "v8e.journal.envoi.facturationExclue": "Billing events excluded.",
  "v8e.journal.envoi.reussi": "{{quand}} — sent, {{lignes}} row(s), code {{code}}.",
  "v8e.journal.envois": "Latest sends",
  "v8e.journal.envoisVide": "No send yet.",
  "v8e.journal.exportPret": "Export ready — SHA-256 fingerprint {{empreinte}} ({{chaine}}).",
  "v8e.journal.exporterCsv": "Export as CSV",
  "v8e.journal.exports": "Audit exports",
  "v8e.journal.filtres": "Filters",
  "v8e.journal.genererExport": "Generate the audit export",
  "v8e.journal.objet": "Object",
  "v8e.journal.onglet.conservation": "Retention and purge",
  "v8e.journal.onglet.journal": "Log",
  "v8e.journal.onglets": "Log sections",
  "v8e.journal.pagination": "{{debut}}–{{fin}} of {{total}}",
  "v8e.journal.paquetPeriode": "Choose a period (366 days at most) to download the package.",
  "v8e.journal.paquetPret": "Package downloaded — manifest fingerprint {{empreinte}}, recorded in the log.",
  "v8e.journal.phrase": "{{quand}} — {{acteur}}: {{action}} {{objet}}",
  "v8e.journal.portee": "Scope",
  "v8e.journal.portee.identifiant.programme": "Programme identifier",
  "v8e.journal.portee.identifiant.projet": "Project identifier",
  "v8e.journal.portee.organisation": "Whole organisation",
  "v8e.journal.portee.programme": "A programme",
  "v8e.journal.portee.projet": "A project",
  "v8e.journal.precedents": "Newer",
  "v8e.journal.pseudonymiser": "Pseudonymise people",
  "v8e.journal.replier": "Hide technical details",
  "v8e.journal.siem": "Forwarding to your SIEM",
  "v8e.journal.siem.actif": "Forwarding enabled",
  "v8e.journal.siem.adresse": "Collector address (https)",
  "v8e.journal.siem.enregistree": "Destination saved.",
  "v8e.journal.siem.enregistrer": "Save the destination",
  "v8e.journal.siem.facturation": "Include billing events",
  "v8e.journal.siem.facturationNonTenue": "You cannot see billing: it cannot be included.",
  "v8e.journal.siem.format": "Format",
  "v8e.journal.siem.nonVisible": "SIEM forwarding is reserved to those who export the log.",
  "v8e.journal.siem.reference": "Token reference in the secret store",
  "v8e.journal.siem.referenceAide": "Never the value: only its name (lowercase letters and digits, 40 at most).",
  "v8e.journal.siem.relais": "Sends go through the platform relay; until it is in service, nothing is sent.",
  "v8e.journal.signatureK15": "SHA-256 fingerprint only: the organisation signature is not available yet.",
  "v8e.journal.source": "Source",
  "v8e.journal.suivants": "Older",
  "v8e.journal.telechargerPaquet": "Download the audit package"
}
